import React, {useEffect} from 'react';
import { AuthContext } from './context';
import { useSelector, useDispatch } from 'react-redux';
//import { Alarm } from 'react-bootstrap-icons';
//import { Alarm } from 'react-ionicons';
import { FaClock } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { allProducts } from '../actions';
import axios from 'axios';


const Product = () => {

    const loginState = useSelector(state => state.currentLogin); //consolidated new Redux login state
    const { signOut } = React.useContext(AuthContext);
    const products = useSelector((state) => state.allProducts.products);
    const dispatch = useDispatch();  //assign useDispatch to use...

    useEffect(() => {
        const fetchProducts = async () => {
            await axios
                .get('/product/list', { headers: {Authorization: loginState.token} })
                .then(response => {
                    console.log('[*] Product Listing (Redux state)', response.data);
                    dispatch(allProducts(response.data));
                })
                .catch((err) => {
                    console.log('❌ ProductListing: ' + err);
                    signOut(); //signout if we get an error to retrieve data... we can take action on different errors 401, 403, etc...
                });
        };
        fetchProducts();
    }, [dispatch, loginState, signOut]);
    
    const renderProductList = products.map((product) => {
        const {id, name, imageName, price, waitingTime, description} = product;
        return(
            <div className="col" key={id} style={{ marginTop: 50 }}>
                <div className="card shadow-sm">
                    <Link to={`/productDetail/${id}`} className="btn-primary stretched-link">
                        <img className="bd-placeholder-img card-img-top" src={imageName} alt=""></img>
                    </Link>
                    <div className="card-body">
                        <h5>{name}</h5>
                        <p className="card-text">{description}</p>
                        <strong>${price}</strong>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="btn-group">
                            </div>
                            <small className="text-muted"><FaClock/> {waitingTime} mins</small>
                        </div>
                    </div>
                </div>
            </div>
        );
    }); 

    return (
        <>{renderProductList}</>
    );
}
export default Product;